module.exports = __webpack_public_path__ + "img/foot.8a0b2f7b.png";